import placeNames from '../map/finland-geonames-place-names.json';

/**
 * Every Latin-script name variant of the 910 GeoNames Finnish places (canonical, ASCII, exonyms
 * such as Helsingfors, Åbo, Esbo), lowercased: exactly the keys of finland-geonames-places.json,
 * written alongside it by scripts/generate-finland-geonames-map-table.ts.
 *
 * Kept separate from utils/map/finland-geonames-lookup.ts because Finland detection only needs
 * the names, while that table also carries coordinates and populations (and the admin1/geo-cell
 * tables via computeGeoCell): about 230 KB this module keeps out of every page's bundle.
 */
const FINLAND_PLACE_NAMES: ReadonlySet<string> = new Set(placeNames as string[]);

/**
 * True when `name` (already trimmed to a single place/segment, not a full "City, Country"
 * string) is a known Finnish place: canonical name, ASCII form, or exonym.
 */
export function isKnownFinlandPlaceName(name: string): boolean {
  return FINLAND_PLACE_NAMES.has(name.trim().toLowerCase());
}
